<div class="navbar-s navbar-fixed-top shadow-header" style="position: fixed;">
  <div class="container-header" style="width: 100%">

    <div class="header-logo">
      <img src="assets/images/logo_omnikles_rvb.png" class="logo-oks" alt="omnikles">
    </div>
    <div class="header-logo" style="float: right;">
      <img src="assets/images/certinomis.svg" class="logo-crtnms" alt="certinomis">
    </div>

  </div>
</div>
